import { render, staticRenderFns } from "./customerServicePersonnel.vue?vue&type=template&id=11b8f4fa&scoped=true&"
import script from "./customerServicePersonnel.vue?vue&type=script&lang=js&"
export * from "./customerServicePersonnel.vue?vue&type=script&lang=js&"
import style0 from "./customerServicePersonnel.vue?vue&type=style&index=0&id=11b8f4fa&prod&lang=stylus&scoped=true&"
import style1 from "./customerServicePersonnel.vue?vue&type=style&index=1&id=11b8f4fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8f4fa",
  null
  
)

export default component.exports